<div [formGroup]="formGroup" style="display: flex; flex-direction: column; padding: 20px">
  <p>Enter your email below to stay informed about the latest updates from Daybook.</p>
  <br>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input formControlName="email" matInput placeholder="Enter you email here" />
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="submit()">Stay Informed</button>
</div>
